import { useEffect, useState } from "react";
import { GFetch } from "../GFetch";
import { ScreenWrapper } from "../components/common"
import { SaleInfoCandeled, SaleInfoCreated, SaleInfoPaid } from "../components/info"; // Исправил опечатку

export const Info = ({ orderCode }) => {
    const [saleInfo, setSaleInfo] = useState();
    const [cancelSaleAsk, setCancelSaleAsk] = useState(false);
    const [cancelSaleResult, setCancelSaleResult] = useState(null); // Изменил на null

    useEffect(() => {
        getSaleInfo();
    }, []);

    const cancelSaleHandler = () => {
        GFetch('POST', 'sale/' + orderCode + '/cancel', {})
            .then((res) => {
                setCancelSaleResult(res); // Сохраняем весь ответ, а не только success

                if (res.success) {
                    // При успехе - сбрасываем состояние и обновляем информацию
                    setCancelSaleAsk(false);
                    setSaleInfo(null); // Сбрасываем чтобы показать загрузку
                    getSaleInfo();
                }
            })
            .catch(() => {
                // На случай сетевой ошибки
                setCancelSaleResult({
                    success: false,
                    error: 'Сетевая ошибка при отмене заказа'
                });
            });
    }

    const getSaleInfo = () => {
        GFetch('POST', 'sale/' + orderCode, {})
            .then((res) => {
                setSaleInfo(res)
            })
    }

    const saleInfoRenderHandler = (status) => {
        switch (status) {
            case 'created':
                return <SaleInfoCreated saleInfo={saleInfo} />
            case 'canceled':
                return <SaleInfoCandeled saleInfo={saleInfo} /> // Исправил опечатку
            case 'paid':
                return <SaleInfoPaid saleInfo={saleInfo} setCancelSaleAsk={setCancelSaleAsk} />
            default:
                return <SaleInfoCreated saleInfo={saleInfo} />
        }
    }

    // Функция для отображения ошибки отмены
    const renderCancelError = () => {
        if (!cancelSaleResult || cancelSaleResult.success !== false) {
            return null;
        }

        return (
            <div className="order_cancel-error">
                <p style={{ color: 'red', marginBottom: '10px' }}>
                    <strong>Отмена невозможна:</strong> {cancelSaleResult.error}
                </p>
                
                {/* Если есть детали о штрихкодах - показываем их */}
                {cancelSaleResult.barcode_details && (
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
                        <p>Причины блокировки:</p>
                        {cancelSaleResult.barcode_details.blocked_reasons?.map((reason, index) => (
                            <div key={index} style={{ marginLeft: '10px' }}>
                                • Штрихкод {reason.barcode}: {reason.reason}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }
    
    return (
        <ScreenWrapper>
            <div className="sale_info-block">
                {saleInfo &&
                    <>
                        {cancelSaleAsk ?
                            <>
                                <div className="order_cancel-block">
                                    <span className="order_cancel-title">Отмена заказа 🥺</span>
                                    <div className="order_cancel_caption-block">
                                        <span className="order_cancel-text">Вы уверены что хотите отменить заказ {saleInfo.number} ?</span>
                                        <p className="order_cancel-description">
                                            Отменив заказ вы не сможете:<br />
                                            — посетить бассейн на крыше<br />
                                            — побывать на массаже и SPA<br />
                                            — перекусить в отличном ресторане<br />
                                            — поплавать у бара<br />
                                            — побывать на интересных банных церемониях
                                        </p>
                                    </div>
                                    
                                    {/* Показываем ошибку с деталями */}
                                    {renderCancelError()}
                                    
                                    <div className="order_cancel_btn-block">
                                        <span className="order_cancel-btn order_cancel-btn_yes" onClick={cancelSaleHandler}>Отменить</span>
                                        <span className="order_cancel-btn order_cancel-btn_no" onClick={() => {
                                            setCancelSaleAsk(false);
                                            setCancelSaleResult(null); // Сбрасываем результат при отказе
                                        }}>Я передумал</span>
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                <span className="sale_info_title">Заказ {saleInfo.number}</span>
                                { saleInfoRenderHandler(saleInfo.status) }
                            </>
                        }
                    </>
                }
            </div>
        </ScreenWrapper>
    )
}